import apiConfig from "constants/apiConfig";
import { AddContactPayload, BulkAddContactsPayload, Contact, ContactResponse, CreatorContactsFilters, UpdateContactMobilePayload } from "types/creators";
import { Influencer } from "types/influencer";
import axiosClient from "utils/axiosClient";

export const fetchContacts = async (hubId: string, filters?: CreatorContactsFilters): Promise<ContactResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_CONTACTS.url.replace('<hubId>', hubId), {
        params: filters,
    });
    return response.data;
}

export const addContact = async (hubId: string, payload: AddContactPayload): Promise<any> => {
    const response = await axiosClient.post(apiConfig.CREATE_CONTACT.url.replace('<hubId>', hubId), payload);
    return response.data;
}

export const bulkAddContacts = async (hubId: string, payload: BulkAddContactsPayload): Promise<any> => {
    const response = await axiosClient.post(
        apiConfig.BULK_CREATE_CONTACT.url.replace('<hubId>', hubId),
        payload
    );
    return response.data;
}

export const updateContactTags = async (hubId: string, socialAccountId: string, tags: string[]): Promise<Contact> => {
    const response = await axiosClient.put(apiConfig.UPDATE_CONTACT_TAGS.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId), {
        tags,
    });
    return response.data;
}

export const updateContactMobile = async (
    hubId: string,
    socialAccountId: string,
    payload: UpdateContactMobilePayload
): Promise<{ influencer: Influencer }> => {
    const response = await axiosClient.post(
        apiConfig.UPDATE_CONTACT_MOBILE.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId),
        payload
    );
    return response.data;
}